import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core'

interface LevelOfSpecificationStyleProps {
    isProjectTasksEnabled?: boolean
}

/**
 * Styles for Level of Specification Icon
 */
export const useLevelOfSpecificationStyles = makeStyles((theme) => ({
    thunderBoltIconContainer: {
        display: 'inline-flex',
        alignItems: 'center',
        alignSelf: 'flex-start',
        left: theme.spacing(-14.5),
        top: 0,
        marginTop: pxToRem(2),
        zIndex: 2,
        pointerEvents: 'auto',
        justifyContent: 'center',
        flexShrink: 0,
    },
    thunderBoltIconButton: {
        display: 'inline-flex',
        width: pxToRem(24),
        height: pxToRem(24),
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(0.5),
        // When Project Tasks is enabled, LOS shifts 24px left to reserve the indicator slot
        marginLeft: ({ isProjectTasksEnabled }: LevelOfSpecificationStyleProps) =>
            isProjectTasksEnabled ? pxToRem(-284) : pxToRem(-230),
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        borderRadius: theme.spacing(0.5),
        '&:focus': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: '2px',
        },
        '&:focus-visible': {
            outline: `3px solid ${theme.palette.primary.main}`,
            outlineOffset: '2px',
            boxShadow: `0 0 0 4px ${theme.palette.background.paper}`,
        },
        '&:hover': {
            background: '#EEEEEE',
            borderRadius: '2px',
            transition: 'all 0.2s ease-in-out',
        },
        '&:active': {
            background: theme.palette.action.selected,
        },
        '& svg': {
            display: 'block',
        },
    },
}))
